module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAL1JREFUeNpiYBgFwx0wkqtRSlxaH0gJ4FFy4dnLpx9xSbJQ4OgJQOyARfwDEBcALT2ITzMTlUNwARArAC1dSEghC5UsvECML6nt4wMgS6HxLk+sJmr42AFqOcwRjvSw+ALMt1DwgF4+/kBKvNIyVY9aPGrxqMWjFuNtAPgTI0b1FgjQkv3QMlkBqXwG1cGOpJhDblmdgKVqpHkcF0CbNyhNHbo09qANPZgvHYDBfJFuqRJkOdQBo2BwA4AAAwD4iC7S3jd59AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/vent/11.png
// module id = 766
// module chunks = 0